// src/components/Footer.jsx
import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation()
  return (
    <footer style={{ textAlign: 'center', padding: '20px 16px 28px', borderTop: '1px solid var(--border)', marginTop: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 20, flexWrap: 'wrap', marginBottom: 10 }}>
        <Link to="/legal#disclaimer" style={{ fontSize: 13, color: 'var(--gray-600)', textDecoration: 'none' }}>{t('footer.disclaimer')}</Link>
        <Link to="/legal#privacy"    style={{ fontSize: 13, color: 'var(--gray-600)', textDecoration: 'none' }}>{t('footer.privacy')}</Link>
        <Link to="/legal#terms"      style={{ fontSize: 13, color: 'var(--gray-600)', textDecoration: 'none' }}>{t('footer.terms')}</Link>
        <a href="mailto:tecfin@kempu.in" style={{ fontSize: 13, color: 'var(--brand-600)', textDecoration: 'none', fontWeight: 600 }}>
          <i className="ti ti-mail" style={{ fontSize: 13, marginRight: 4 }} aria-hidden="true" />
          tecfin@kempu.in
        </a>
      </div>
      <p style={{ fontSize: 12, color: 'var(--gray-400)', marginTop: 6 }}>
        {t('footer.copyright', { year: new Date().getFullYear() })}
      </p>
    </footer>
  )
}
